<div class="container">
    <mat-card class="card-firmaE">
        <mat-card-content>
            <form name="formSign" [formGroup]="formSign">
                <div fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
                     fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch">

                    <mat-form-field  appearance="outline" fxFlex="100%" class="full-width-input">
                        <mat-label>Certificado (cer)</mat-label>
                        <ngx-mat-file-input required formControlName="certificado" placeholder="Seleccione el certificado"
                                            [accept]="'.cer'" (change)="handleFileSelect($event)">
                        </ngx-mat-file-input>
                        <mat-icon matSuffix>folder</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="100%" class="full-width-input">
                        <mat-label>Clave privada (key)</mat-label>
                        <ngx-mat-file-input required     formControlName="llave" placeholder="Seleccione la llave privada"
                                            [accept]="'.key'" (change)="handleFileSelect($event)">
                        </ngx-mat-file-input>
                        <mat-icon matSuffix>folder</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" fxFlex="100%" class="full-width-input">
                        <mat-label>Contraseña</mat-label>
                        <input required matInput [type]="hide ? 'password' : 'text'" formControlName="password" cleanWhiteSpace>
                        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </form>
            <div fxLayout="row" fxLayoutAlign="end end">
                <button mat-raised-button color="accent" [disabled]="!formSign.valid" (click)="firmar()">
                    Firmar
                </button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
